import Card from './Card';
import { CardProps, CardValueProps } from './types';

export type { CardProps, CardValueProps };
export default Card;
